import { type PropsWithChildren } from 'react';

import s from './FieldLabel.module.scss';

type Props = {
  compact?: boolean;
  className?: string;
  isValid?: boolean;
  id: string;
  labelId?: string;
  testId?: string;
};

const FieldLabel: React.FC<PropsWithChildren<Props>> = ({
  children,
  compact = true, // default to true for backwards compatability
  className,
  isValid = true,
  id,
  labelId,
  testId,
}) => (
  <label
    id={labelId}
    htmlFor={id}
    className={[
      s['field-label'],
      compact ? s['field-label--compact'] : s['field-label--not-compact'],
      ...(className ? [className] : []),
      ...(!isValid ? [s['field-label--error']] : []),
    ].join(' ')}
    {...(testId && { 'data-testid': testId })}
  >
    {children}
  </label>
);

export default FieldLabel;
